import PropTypes from 'prop-types';
import React from 'react';

import ContentContainer from './ContentContainer';
import * as styles from './PageSection.module.scss';

const PageSection = ({
  className,
  children,
  fullBleed = false,
  backgroundImage,
  wide = false,
  noPad,
  isTopSection = false,
  curveTop = false,
  curveBottom = false,
  slim,
  moderate,
  innerClassName,
  gapFix = false,
  ...rest
}) => {
  const top = curveTop ? styles.curveTop : '';
  const bottom = curveBottom ? styles.curveBottom : '';
  return (
    <section
      className={[
        top,
        bottom,
        slim ? styles.slim : (moderate && styles.moderate) || '',
        isTopSection ? styles.topSection : styles.pageSection,
        noPad ? styles.noPad : '',
        styles.width,
        className,
      ].join(' ')}
      {...rest}
    >
      {!!backgroundImage && (
        <div className={styles.backgroundImage}>
          <img src={backgroundImage.file?.url} alt={'Background'} />
        </div>
      )}
      <ContentContainer wide={wide} noPad={noPad} fullBleed={fullBleed} gapFix={gapFix} className={innerClassName}>
        {children}
      </ContentContainer>
    </section>
  );
};

PageSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  fullBleed: PropTypes.bool,
  wide: PropTypes.bool,
  isTopSection: PropTypes.bool,
  curveTop: PropTypes.bool,
  curveBottom: PropTypes.bool,
};

export default PageSection;
